import { Subject } from 'rxjs';
import * as rateCard from './rateCard';
import * as bandwidthConstants from '../constants/bandwidth';
import * as blockConstants from '../constants/blockStorage';
import * as gpuConstants from '../constants/gpu';


const subject = new Subject();
const initialState = {
  showButton: true,
  show: false,
  aws: 0,
  oci: 0,
  category: 'bandwidth',
  subCategory: 'balanced',
  awsComputeCost: 0,
  awsBlockCost: 0,
  ociComputeCost: 0,
  ociBlockCost: 0,
  compute: 0,
  block: 0,
  amount: "",
  egress: "",
  blockStorage: "",
  stdCompute: "",
  gpuServices: "",
  computeSlider: 50,
  blockSlider: 50,
  totalAWSCost: 0,
  totalOCICost: 0,
  totalSave: 0,
  percentage: 0,
  awsEgress: 0,
  ociEgress: 0,
  awsStdCompute: 0,
  ociStdCompute: 0,
  awsGPU: 0,
  ociGPU: 0,
  awsBlockStorage: 0,
  ociBlockStorage: 0,
  totalBYO_AWSCost: 0,
  totalBYO_OCICost: 0,
  totalBYOSave: 0,
  percentageBYO: 0,
  cores: 2,
  blockVol: 100,
  coresVal: 0,
  awsCores: 0,
  ociCores: 0,
  blockVolVal: 0,
  awsBlockVol: 0,
  ociBlockVol: 0,
  totalComputeAWS: 0,
  totalComputeOCI: 0,
  totalComputeSave: 0,
  totalComputePercentage: 0


};

let state = initialState;

const bandwidthStore = {
  init: () => {
    subject.next(state);
  },
  subscribe: setState => subject.subscribe(setState),
  reset: () => {
    state = {
      ...initialState,
    };
    subject.next(state);
  },
  updateAmount: val => {
    state = {
      ...state,
      amount: val
    };
    subject.next(state); 
  },
  updateBYOValues: (name, val) => {
    state = {
      ...state,
      [name]: val,
    };
    subject.next(state);
  },
  hide: () => {
    state = {
      ...state,
      show: false,
    };
    subject.next(state);
  },
  showResults: () => {
    state = {
      ...state,
      show: true,
    };
    subject.next(state);
  },
  hideSubmitButton: () => {
    state = {
      ...state,
      showButton: false
    };
    subject.next(state);
  },
  showSubmitButton: () => {
    state = {
      ...state,
      showButton: true
    };
    subject.next(state);
  },
  selectCategory: id => {
    state = {
      ...state,
      category: id
    };
    subject.next(state);
  },
  updateSubCategory: id => {
    state = {
      ...state,
      subCategory: id
    };
    subject.next(state);
  },

  updateComputeSlider: slider => {
    state = {
      ...state,
      computeSlider: slider
    };
    subject.next(state);
  },
  updateBlockVolSlider: slider => {
    state = {
      ...state,
      blockVol: slider
    };
    subject.next(state);
  },
  updateBlockSlider: slider => {
    state = {
      ...state,
      blockSlider: slider
    };
    subject.next(state);
  },
  updateCoresSlider: slider => {
    state = {
      ...state,
      cores: slider
    };
    subject.next(state);
  },
  calculateSliderConstants: amount => {
    const constants = state.category === 'bandwidth' ? bandwidthConstants : (state.category === 'block'? blockConstants: gpuConstants);
    const balanced = {
      compute: Math.round(amount*(constants.balancedCompute)*state.computeSlider*0.01*2),
      block: Math.round(amount*(constants.balancedBlock)*state.blockSlider*0.01*2),
    };
     
    const heavy = {
      compute:  Math.round(amount*(constants.heavyCompute)*state.computeSlider*0.01*2),
      block:  Math.round(amount*(constants.heavyBlock)*state.blockSlider*0.01*2),
    };

    const light = {
      compute:  Math.round(amount*(constants.lightCompute)*state.computeSlider*0.01*2),
      block:  Math.round(amount*(constants.lightBlock)*state.blockSlider*0.01*2)
    };
      
    const values = state.subCategory === 'balanced' ? balanced : (state.subCategory === 'heavy' ? heavy : light);
      
    state = {
      ...state,
      compute: values.compute,
      block: values.block
      
    };
    subject.next(state);
  },
  calculateTotalValues: () => {
    state = {
      ...state,
      totalAWSCost: state.aws+ state.awsComputeCost + state.ociBlockCost,
      totalOCICost: state.oci + state.ociBlockCost + state.ociComputeCost,
      
    };
    subject.next(state);
  },
  calculateSavings: () => {
    state = {
      ...state,
      totalSave: Math.round(state.totalAWSCost - state.totalOCICost).toLocaleString(undefined),
      percentage: state.totalAWSCost === 0 ? 0: Math.round((state.totalAWSCost - state.totalOCICost)/state.totalAWSCost*100).toLocaleString(undefined),
    };
    subject.next(state);
  },
  calculateValues: () => {

    const ociBalancedBlock = state.block*(rateCard.ociBlock + 10*rateCard.ociVpu);
    const ociHeavyBlock = state.block*(rateCard.ociBlock + 10*rateCard.ociVpu);
    const ociLightBlock = state.block*(rateCard.ociBlock + 10*rateCard.ociVpu);

    const balanced = {
      ociBlock: ociBalancedBlock,
      ociCompute: state.compute*(rateCard.ociCompute)*744,
      awsBlock: state.block*(rateCard.awsBlock),
      awsCompute: state.compute*(rateCard.awsCompute)*744,
    };

    const heavy = {
      ociBlock: ociHeavyBlock,
      ociCompute: state.compute*(rateCard.ociCompute)*744,
      awsBlock: state.block*(rateCard.awsBlock),
      awsCompute: state.compute*(rateCard.awsCompute)*744,
    };

    const light = {
      ociBlock: ociLightBlock,
      ociCompute: state.compute*(rateCard.ociCompute)*744,
      awsBlock: state.block*(rateCard.awsBlock),
      awsCompute: state.compute*(rateCard.awsCompute)*744,
    };

    const values = state.subCategory === 'balanced' ? balanced : (state.subCategory === 'heavy' ? heavy : light)

    state = {
      ...state,
      awsComputeCost: values.awsCompute,
      ociComputeCost: values.ociCompute,
      awsBlockCost: values.awsBlock,
      ociBlockCost: values.ociBlock,
    };
    subject.next(state);
  },
  calculateBandwidth: amount => {
    let final = 0.00;
    if (amount < 1) {
      final = 0.00
    } else if(amount*1024 >= bandwidthConstants.awsMin1 && amount*1024 <= bandwidthConstants.awsMax1) {
      final = final + amount*1024*rateCard.awsEgress1;
    } else if(amount*1024 >= bandwidthConstants.awsMin2 && amount*1024 <= bandwidthConstants.awsMax2) {
      final = final + bandwidthConstants.awsMax1*rateCard.awsEgress1 
                    + (amount*1024 - bandwidthConstants.awsMax1)*rateCard.awsEgress2
    } else if(amount*1024 >= bandwidthConstants.awsMin3 && amount*1024 <= bandwidthConstants.awsMax3) {
      final = final + bandwidthConstants.awsMax1*rateCard.awsEgress1
                    + (bandwidthConstants.awsMax2 - bandwidthConstants.awsMin2)*rateCard.awsEgress2
                    + (amount*1024 - bandwidthConstants.awsMax2)*rateCard.awsEgress3
    } else if(amount*1024 >= bandwidthConstants.awsMin4) {
      final = final + bandwidthConstants.awsMax1*rateCard.awsEgress1 
                    + (bandwidthConstants.awsMax2 - bandwidthConstants.awsMin2)*rateCard.awsEgress2 
                    + (bandwidthConstants.awsMax3 - bandwidthConstants.awsMin3)*rateCard.awsEgress3
                    + (amount*1024 - bandwidthConstants.awsMax3)*rateCard.awsEgress4
    }
    const bandwidth = {
      aws: final,
      oci: amount*1024 < 10240 ? 0 : (amount*1024 - 10240)*rateCard.ociEgress,
    };

    state = {
      ...state,
      aws: bandwidth.aws,
      oci: bandwidth.oci,
      awsEgress: bandwidth.aws,
      ociEgress: bandwidth.oci
    };
    subject.next(state);

  },

  calculateBlock: amount => {
    const block = {
      aws: amount*1024*rateCard.awsHighBlock + (amount*1024)/500*35000*rateCard.awsIops,
      oci: amount*1024*(rateCard.ociBlock + 20*rateCard.ociVpu),
    };
    state = {
      ...state,
      aws: block.aws,
      oci: block.oci,
      awsBlockStorage: block.aws,
      ociBlockStorage: block.oci
    };
    subject.next(state);

  },

  calculateStdCompute: (amount, cores, blockVol) => {

    const aws_cores = cores === 3 ? 4 : ((cores > 4 && cores < 8) ? 8 : ((cores > 8 && cores < 16) ? 16 : ((cores > 16 && cores < 24) ? 24 : ((cores > 24 && cores < 32) ? 32 : ((cores > 32 && cores <= 48) ? 48 : (cores > 48 ? 'NA' : cores))))));

    const stdCompute = {
      awsCores: cores > 48 ? 'N/A' : amount*744*aws_cores*rateCard.awsCompute,
      ociCores: amount*744*cores*rateCard.ociCompute,
      awsBlockVol: cores > 48 ? 'N/A' :  amount*blockVol*rateCard.awsBlock,
      ociBlockVol: amount*blockVol*(rateCard.ociBlock + 10*rateCard.ociVpu)
    };

    const totals = {
      totalComputeAWS: cores > 48 ? 'N/A' : stdCompute.awsCores + stdCompute.awsBlockVol,
      totalComputeOCI: stdCompute.ociCores + stdCompute.ociBlockVol,
    }

    const final = {
      totalSave: cores > 48 ? 'N/A' : totals.totalComputeAWS - totals.totalComputeOCI,
      percentage: cores > 48 ? 'N/A' : ((totals.totalComputeAWS - totals.totalComputeOCI)/totals.totalComputeAWS)*100
    }

    state = {
      ...state,
      coresVal: amount*744*cores,
      awsCores: stdCompute.awsCores,
      ociCores: stdCompute.ociCores,
      blockVolVal: amount*blockVol,
      awsBlockVol: stdCompute.awsBlockVol,
      ociBlockVol: stdCompute.ociBlockVol,
      totalComputeAWS: totals.totalComputeAWS,
      totalComputeOCI: totals.totalComputeOCI,
      totalComputeSave: Math.round(final.totalSave).toLocaleString(undefined),
      totalComputePercentage: Math.round(final.percentage).toLocaleString(undefined)
      
    };
    subject.next(state);
  },
  calculateHpc: amount => {
    const hpc = {
      aws: amount*744*rateCard.awsGpu,
      oci: amount*744*rateCard.ociGpu,
    };

    state = {
      ...state,
      aws: hpc.aws,
      oci: hpc.oci,
      awsGPU: hpc.aws,
      ociGPU: hpc.oci
    };
    subject.next(state);
  },
  calculateCompute: amount => {
    const compute = {
      aws: amount*rateCard.awsCompute*744,
      oci: amount*rateCard.ociCompute*744
    }
    state = {
      ...state,
      aws: compute.aws,
      oci: compute.oci,
      awsStdCompute: compute.aws,
      ociStdCompute: compute.oci
    };
    subject.next(state);
  },

  calculateBYOTotalValues: () => {
    state = {
      ...state,
      totalBYO_AWSCost: state.awsEgress + state.awsBlockStorage + state.awsStdCompute + state.awsGPU,
      totalBYO_OCICost: state.ociEgress + state.ociBlockStorage + state.ociStdCompute + state.ociGPU,
    };
    subject.next(state);
  },
  calculateBYOSavings: () => {
    state = {
      ...state,
      totalBYOSave: Math.round(state.totalBYO_AWSCost - state.totalBYO_OCICost).toLocaleString(undefined),
      percentageBYO: state.totalBYO_AWSCost === 0 ? 0 : Math.round((state.totalBYO_AWSCost - state.totalBYO_OCICost)/state.totalBYO_AWSCost*100).toLocaleString(undefined)
    };
    subject.next(state);
  },
  initialState
};

export default bandwidthStore;
